import { DropdownItem } from '@distribusion/owl-frontend-ui'
import { Field, FieldProps } from 'formik'
import React, { ReactElement } from 'react'

import { required } from '@lib/validators'
import TimeSelector from '@ui/TimeSelector'

interface DepartureTimeFieldProps {
  name: string
  label: string
  options?: DropdownItem<string>[]
  forcedInitialValue?: string | null
  loadConnections?: boolean
  timeAllowance?: number
}

const DepartureTimeField = ({
  name,
  label,
  options,
  forcedInitialValue,
  loadConnections,
  timeAllowance,
}: DepartureTimeFieldProps): ReactElement => (
  <Field name={name} validate={forcedInitialValue ? undefined : required}>
    {({ field: { value, name }, meta: { error, touched }, form: { setFieldValue } }: FieldProps) => (
      <TimeSelector
        value={value ?? forcedInitialValue}
        onChange={updatedValue => {
          setFieldValue(name, updatedValue)
        }}
        label={label}
        options={options}
        errorMessage={touched ? error : undefined}
        loadConnections={loadConnections ?? false}
        timeAllowance={timeAllowance ?? 0}
      />
    )}
  </Field>
)

export default DepartureTimeField
